import { useEffect, useState } from "react";
import WhatsAppIcon from "@/components/WhatsAppIcon";
import analytics from "@/utils/analytics";
import { whatsAppUrl, whatsAppReplyPromise } from "@/utils/whatsapp";

// Persistent bottom-right entry point. Lifts above StickyQuoteBar (fixed
// bottom-0 z-40) when that bar is showing; StickyQuoteBar appears after
// 600px of scroll, so we mirror that threshold.
export default function WhatsAppFloat() {
  const [visible, setVisible] = useState(false);
  const [lifted, setLifted] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 1200);
    const onScroll = () => {
      if (window.scrollY > 200) setVisible(true);
      setLifted(window.scrollY > 600);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => {
      clearTimeout(timer);
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (
    <a
      href={whatsAppUrl("float")}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => analytics.clickWhatsApp("float")}
      aria-label="Chat with CanDo Payments on WhatsApp"
      title={whatsAppReplyPromise()}
      data-testid="whatsapp-float"
      className={[
        "fixed z-30 right-4 md:right-6 group",
        "flex items-center justify-center gap-0 md:hover:gap-2",
        "h-14 w-14 md:h-15 md:w-15 md:hover:w-auto md:hover:px-5",
        "rounded-full bg-brand-whatsapp hover:bg-brand-whatsapp-dark text-white",
        "shadow-[0_4px_14px_rgba(0,0,0,0.18)] hover:shadow-[0_6px_20px_rgba(0,0,0,0.24)]",
        "transition-all duration-300 motion-reduce:transition-none",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2",
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3 pointer-events-none",
        lifted ? "bottom-24 md:bottom-24" : "bottom-5 md:bottom-6",
      ].join(" ")}
    >
      <WhatsAppIcon size={28} className="shrink-0" />
      <span className="hidden md:inline-block max-w-0 overflow-hidden whitespace-nowrap text-sm font-semibold opacity-0 transition-all duration-300 group-hover:max-w-[10rem] group-hover:opacity-100">
        Chat on WhatsApp
      </span>
    </a>
  );
}
